import { TransformControls as DreiTransformControls } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import { useEffect, useState } from "react";

type TransformControlsProps = {
    selectedModelUUID: string | null;
    onModelChange?: (
        uuid: string,
        xPosition: number,
        yPosition: number,
        zPosition: number,
        xRotaton: number,
        yRotaton: number,
        zRotaton: number
    ) => void;
    skipSettingModelData: boolean;
};

export const TransformControls = ({ selectedModelUUID, skipSettingModelData, onModelChange }: TransformControlsProps) => {
    const scene = useThree(state => state.scene);
    const selected3DObject = selectedModelUUID ? scene.getObjectByProperty('uuid', selectedModelUUID) : null;
    const [transformControlsMode, setTransformControlsMode] = useState<'translate' | 'rotate'>('translate');
    const [prevSelectedId, setPrevSelectedId] = useState(selectedModelUUID);

    useEffect(() => {
        if (selectedModelUUID && selected3DObject) {
            const handleKeydown = (event: KeyboardEvent) => {
                if (event.key?.toLowerCase() === 'r') setTransformControlsMode('rotate');
                else if (event.key?.toLowerCase() === 't') setTransformControlsMode('translate');
            };

            window.addEventListener('keydown', handleKeydown);

            return () => {
                window.removeEventListener('keydown', handleKeydown);
            };
        }
    }, [selectedModelUUID, selected3DObject]);
    
    if (prevSelectedId !== selectedModelUUID) {
        setPrevSelectedId(selectedModelUUID);
        setTransformControlsMode('translate');
    }

    useFrame(() => {
        if (!selected3DObject || selectedModelUUID === null || skipSettingModelData) return;

        if (onModelChange)
            onModelChange(
                selectedModelUUID,
                selected3DObject.position.x,
                selected3DObject.position.y,
                selected3DObject.position.z,
                selected3DObject.rotation.x,
                selected3DObject.rotation.y,
                selected3DObject.rotation.z
            );
    });

    if (selected3DObject)
        return <DreiTransformControls object={selected3DObject} mode={transformControlsMode} />;
    else return null;
};